import React, { useState } from "react";
import { useSelector } from "react-redux";
import { isMobile } from "react-device-detect";
import styled, { css } from "styled-components";
import PropTypes from "prop-types";

import breakpoints from "_constants/breakpoints";

import OrderTableMobile from "components/OrderTable/OrderTableMobile";
import OrderTableDesktop from "components/OrderTable/OrderTableDesktop";
import Pagination from "components/Pagination/Pagination";
import { SpinnerWrapper } from "widget/Spinner";
import { ErrorModal } from "components/Modals/ErrorModal";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #ffffff;
  min-height: 500px;

  animation: 0.2s linear fadeIn;
  @keyframes fadeIn {
    from {
      opacity: 0%;
    }
    to {
      opacity: 100%;
    }
  }

  ${({ theme: { mobile } }) =>
    mobile &&
    css`
      padding: 0 10px;

      @media (max-width: ${breakpoints.mobileM}) {
        padding: 0;
      }
    `}
`;
// const ContentContainer = styled.div`
//   animation: 0.2s linear fadeIn;
//   @keyframes fadeIn {
//     from {
//       opacity: 0%;
//     }
//     to {
//       opacity: 100%;
//     }
//   }
// `;

function Dashboard(props) {
  const { scrollToContent } = props;

  const { ordersList, error, ordersListLoading } = useSelector(({ orders }) => orders);

  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(ordersList.length / 10);
  const orderToShow = ordersList.slice((currentPage - 1) * 10, currentPage * 10);

  if (!ordersList.length || ordersListLoading)
    return (
      <Container key="container-orderlist-alert">
        {(ordersListLoading && <SpinnerWrapper />) || (error && <ErrorModal />)}
      </Container>
    );

  return (
    <Container key="container-orderlist-main">
      {isMobile ? (
        <OrderTableMobile orderToShow={orderToShow} scrollToContent={scrollToContent} />
      ) : (
        <OrderTableDesktop orderToShow={orderToShow} scrollToContent={scrollToContent} />
      )}
      <Pagination currentPage={currentPage} totalPages={totalPages} onClick={setCurrentPage} />
    </Container>
  );
}

Dashboard.propTypes = {
  scrollToContent: PropTypes.func,
};

export default Dashboard;
